import { darkSurfaceCircleColor, type DecorativeCircleSpec } from "../components/DecorativeCircles";
import { brandColorTokens } from "./brandColorTokens";

export const canucciSurfaceDecorationCircles: DecorativeCircleSpec[] = [
  { size: "18rem", top: "-7rem", right: "-3.5rem", color: darkSurfaceCircleColor },
  { size: "22rem", right: "6rem", bottom: "-12rem", color: darkSurfaceCircleColor },
];

export const canucciThemeIdentityColors = brandColorTokens.themeIdentityMid;

export function canucciThemeIdentityColorAtIndex(index: number): string {
  const colors = canucciThemeIdentityColors;
  const normalizedIndex = ((index % colors.length) + colors.length) % colors.length;
  return colors[normalizedIndex];
}
